import { NursingTaskType } from '@dokucoach/common-types';

export enum NursingTaskCategory {
  ALL = 'ALL',
  TREATMENT_CARE = 'TREATMENT_CARE',
  BASIC_CARE = 'BASIC_CARE',
}

// Behandlungspflege: tasks generated from the medication sheet, care plan page 2
// ("Ausscheiden, Pflegen, Kleiden") and the wound therapy. Everything else is basic care.
const TREATMENT_CARE_TASK_TYPES: ReadonlySet<NursingTaskType> = new Set([
  NursingTaskType.MEDICATION,
  NursingTaskType.PEG,
  NursingTaskType.CATHETERCHANGE,
  NursingTaskType.CATHETERBAG_CHANGE_DAY,
  NursingTaskType.CATHETERBAG_CHANGE_NIGHT,
  NursingTaskType.STOMABAGCHANGE,
  NursingTaskType.STOMAPLATECHANGE,
  NursingTaskType.WOUNDTHERAPY,
]);

export const isInNursingTaskCategory = (
  type: NursingTaskType,
  category: NursingTaskCategory,
): boolean => {
  switch (category) {
    case NursingTaskCategory.TREATMENT_CARE:
      return TREATMENT_CARE_TASK_TYPES.has(type);
    case NursingTaskCategory.BASIC_CARE:
      return !TREATMENT_CARE_TASK_TYPES.has(type);
    default:
      return true;
  }
};
